export const blobColors = ['red', 'orange', 'green', 'purple', 'blue']
